module.exports = __webpack_public_path__ + "static/img/P1.a2d38f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/P1.png
// module id = +uvI
// module chunks = 0